import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import ContactBankSettingBox from '../ContactBankSettingBox'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'

interface ContactBankSettingListingProps {
	data: GetGeneralSettingResponse
}

export default function ContactBankSettingListing({
	data,
}: ContactBankSettingListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าช่องทางติดต่อ"
					description="จัดการช่องทางติดต่อ Line และ Telegram"
				/>
			</div>
			<Separator />
			<ContactBankSettingBox data={data} />
		</div>
	)
}
